<template>
  <v-autocomplete
    v-model="select"
    :items="items"
    :rules="rules"
    :label="label"
    @change="change"
    :readonly="disabled"
    :filter="filter"
    persistent-hint
  >
    <template slot="no-data">
      <v-list-tile>
        <v-list-tile-title>没有匹配项</v-list-tile-title>
      </v-list-tile>
    </template>
    <template slot="selection" slot-scope="{ item }">{{item.Value}}</template>
    <template slot="item" slot-scope="{ item }">
      <v-list-tile-content>
        <!-- <v-list-tile-title v-text="item.Value"></v-list-tile-title> -->
        <v-list-tile-sub-title v-text="item.Value"></v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    value: [String, Boolean],
    items: {
      type: Array,
      default: function() {
        return [];
      }
    },
    label: String,
    disabled: Boolean,
    rules: Array
  },
  data() {
    return {
      select: null
    };
  },
  created() {
    if (this.value) {
      this.select = this.items.find(r => r.Key == this.value);
    }
  },
  watch: {
    value() {
      this.select = this.items.find(r => r.Key == this.value);
    }
  },
  methods: {
    change($event = {}) {
      this.$emit("change", $event);
      this.$emit("input", $event.Key);
    },
    filter(item, queryText) {
      return (
        item.Value.toLowerCase().includes(queryText.toLowerCase()) ||
        item.Key.toLowerCase().includes(queryText.toLowerCase())
      );
    }
  }
};
</script>

<style>
</style>
